module.exports = __webpack_public_path__ + "img/cases-brand-hpnk-lazyload-49.abc27afd.jpg";